/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getStorefrontLoginEntry} from '../api'

 export const useQueryGetStorefrontLoginEntry = createReactQueryHook('getStorefrontLoginEntry', getStorefrontLoginEntry)
